import React, { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { CustomizerProps } from '../../../../shared/prop-types/ReducerProps';

class ToggleTopMenu extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    customizer: CustomizerProps.isRequired,
    toggleTopNavigation: PropTypes.func.isRequired,
  };

  render() {
    const { t, toggleTopNavigation, customizer } = this.props;

    return (
      <label
        className="toggle-btn customizer__toggle"
        htmlFor="top_menu_toggle"
      >
        <input
          className="toggle-btn__input"
          type="checkbox"
          name="top_menu_toggle"
          id="top_menu_toggle"
          checked={customizer.topNavigation}
          onChange={toggleTopNavigation}
          disabled
        />
        <span className="toggle-btn__input-label" />
        <span>{t('toggle_top_menu.menu')}</span>
      </label>
    );
  }
}

export default withTranslation('common')(ToggleTopMenu);
